import addressApi from "@/api/address";


const state = {
    isLoading: false,
    isMore: null,
    nextPage: 1,
    address: null,
    customAddress: null
}

export const mutationTypes = {
    clearAddress: '[address] clearAddress',
    appendAddress: '[address] appendAddress',
    setIsLoading: '[address] setIsLoading',
    setIsMore: '[address] setIsMore',
    setNextPage: '[address] setNextPage',
    setManualSelectedCity: '[address] setManualSelectedCity',
    setManualSelectedStreet: '[address] setManualSelectedStreet',
    setCity: '[address] setCity',
    setSelect2City: '[address] setSelect2City',
    setStreet: '[address] setStreet',
    setSelect2Street: '[address] setSelect2Street',
    setHouse: '[address] setHouse',
    setApartment: '[address] setApartment',
}

export const actionTypes = {
    getAddress: '[address] getAddress',
    removeAddress: '[address] removeAddress',
    createAddress: '[address] createAddress',
    updateAddress: '[address] updateAddress'
}

export const getterTypes = {
    address: '[address] address',
    isLoading: '[address] isLoading',
    isMore: '[address] isMore'
}

const mutations = {
    [mutationTypes.appendAddress](state, address) {
        if (state.address === null){
            const arrProxy = new Proxy(address, {
              get(target, prop) {
                if (prop === 'push') {
                  return (...args) => {
                    console.log(...args);
                    return target[prop](...args);
                  };
                }
                return target[prop];
              }
            });
            state.address = arrProxy
        } else {
            address.forEach((obj) => {
                const found = state.address.find((element) => element.id === obj.id);
                if (!found){
                    state.address.push(obj)
                }
            })
        }
    },
    [mutationTypes.clearAddress](state){
        state.address = null
    },
    [mutationTypes.setIsLoading](state, value){
        state.isLoading = value
    },
    [mutationTypes.setIsMore](state, value){
        state.isMore = value
    },
    [mutationTypes.setNextPage](state, value){
        state.nextPage = value
    },
    [mutationTypes.setManualSelectedCity](state, { id, value }){
      const item = state.address.find(item => item.id === id)

      if (item) {
        item.isManualSelectedCity = value
      }
    },
    [mutationTypes.setManualSelectedStreet](state, { id, value }){
      const item = state.address.find(item => item.id === id)

      if (item) {
        item.isManualSelectedStreet = value
      }
    },
    [mutationTypes.setCity](state, { id, rout_id, text, ref }){
      const item = state.address.find(item => item.id === id)

      if (item) {
        item.city = text
        item.city_ref = ref
        item.route = rout_id
      }
    },
    [mutationTypes.setStreet](state, { id, text }){
      const item = state.address.find(item => item.id === id)

      if (item) {
        item.street = text
      }
    },
    [mutationTypes.setHouse](state, { id, text }){
      const item = state.address.find(item => item.id === id)

      if (item) {
        item.house = text
      }
    },
    [mutationTypes.setApartment](state, { id, text }){
      const item = state.address.find(item => item.id === id)

      if (item) {
        item.apartment = text
      }
    },
    [mutationTypes.setSelect2City](state, { id, option, option_id, ref }){
      const item = state.address.find(item => item.id === id)

      if (item) {
        item.city = option.text
        item.city_ref = ref
        item.route = option_id

        item.selectCityOptions = [option]
        item.select2City = option_id
      }
    },
    [mutationTypes.setSelect2Street](state, { id, option, option_id}){
      const item = state.address.find(item => item.id === id)

      if (item) {
        item.city = option.street

        item.selectStreetOptions = [option]
        item.select2Street = option_id
      }
    }
}

const getters = {
    [getterTypes.address]: state => {
        return state.address
    },
    [getterTypes.isLoading]: state => {
        return state.isLoading
    },
    [getterTypes.isMore]: state => {
        return state.isMore
    }
}

const actions = {
    [actionTypes.getAddress](context) {
        context.commit(mutationTypes.setIsLoading, true)
        let credentials = {}
        if (state.nextPage){
            credentials.page = state.nextPage
        }
        return new Promise(resolve => {
            addressApi
                .getAddress(credentials)
                .then(response => {
                    console.log('response:', response)

                    context.commit(mutationTypes.appendAddress, response.data['results'])
                    context.commit(mutationTypes.setIsLoading, false)

                    if (response.data['next']){
                        context.commit(mutationTypes.setIsMore, true)
                        const url = new URL(response.data['next']);
                        const urlParams = new URLSearchParams(url.search);
                        const nextPage = parseInt(urlParams.get('page'))
                        context.commit(mutationTypes.setNextPage, nextPage)
                        console.log('Next page:', nextPage)
                    } else {
                        context.commit(mutationTypes.setNextPage, null)
                        context.commit(mutationTypes.setIsMore, false)
                    }
                    resolve(response.data['results'])
                })
                .catch(result => {
                    context.commit(mutationTypes.setIsLoading, false)
                    console.log('Result Errors:', result)
                })
        })
    },
    [actionTypes.removeAddress](context, credentials) {
        console.log('removeAddress')
        console.log(credentials)
        context.commit(mutationTypes.setIsLoading, true)
        return new Promise(resolve => {
            addressApi
                .removeAddress(credentials)
                .then(response => {
                    console.log('response:', response)
                    context.commit(mutationTypes.setIsLoading, false)

                    resolve(response)
                })
                .catch(result => {
                    context.commit(mutationTypes.setIsLoading, false)
                    console.log('Result Errors:', result)
                })
        })
    },
    [actionTypes.createAddress](context, credentials) {
        console.log('createAddress')
        console.log(credentials)
        context.commit(mutationTypes.setIsLoading, true)
        return new Promise(resolve => {
            addressApi
                .createAddress(credentials)
                .then(response => {
                    console.log('response:', response)
                    context.commit(mutationTypes.setIsLoading, false)

                    resolve(response)
                })
                .catch(result => {
                    context.commit(mutationTypes.setIsLoading, false)
                    console.log('Result Errors:', result)
                    resolve(result.response)
                })
        })
    },
    [actionTypes.updateAddress](context, credentials) {
        console.log('updateAddress')
        console.log(credentials)
        context.commit(mutationTypes.setIsLoading, true)
        return new Promise(resolve => {
            addressApi
                .updateAddress(credentials)
                .then(response => {
                    console.log('response:', response)
                    context.commit(mutationTypes.setIsLoading, false)

                    resolve(response)
                })
                .catch(result => {
                    context.commit(mutationTypes.setIsLoading, false)
                    console.log('Result Errors:', result)
                })
        })
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}